import { z } from "zod";
import { confirmableConfig, confirmableDefaults } from "./confirmable.js";
import { optionalUnlessRequired, type FieldDescriptor } from "./types.js";

const configSchema = z.object({
  ...confirmableConfig,
  currencyCode: z.string().length(3).default("NGN"),
  min: z.number().nonnegative().optional(),
  max: z.number().positive().optional(),
});

export const currencyField: FieldDescriptor<z.infer<typeof configSchema>> = {
  type: "currency",
  label: "Currency",
  category: "number",
  icon: "Banknote",
  configSchema,
  valueSchema: (config, isRequired) => {
    let schema = z.number({ invalid_type_error: "Enter an amount" }).nonnegative();
    if (config.min !== undefined) schema = schema.min(config.min);
    if (config.max !== undefined) schema = schema.max(config.max);
    // Money is stored as a plain number in JSONB; two decimal places is the presentation contract.
    const withPrecision = schema.refine((value) => {
      const decimals = (String(value).split(".")[1] ?? "").length;
      return decimals <= 2;
    }, "Use at most 2 decimal places");
    return optionalUnlessRequired(withPrecision, isRequired);
  },
  defaultConfig: { ...confirmableDefaults, currencyCode: "NGN" },
  supportsProfileBinding: true,
  defaultSearchable: false,
  sortKind: "numeric",
  renderHints: {},
};
